import React, { useState, useEffect, useRef } from "react";
import { Modal, Button, Row, Col, Form, Card } from "react-bootstrap";
import Select from "react-select";
import axios from "axios";
import * as Icon from "react-bootstrap-icons";
import "../Style/ViewPlannerModal.css";
import useSelfAssignToOptions from "../../Common/ReuseApi/useSelfAssignToOptions";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";

const CreatePlannerModal = ({ show, close, editData, isEdit, getAllPlanner }) => {

    const loginUserData = useSelector((state) => state.loginData.userData)

    const [errors, setErrors] = useState([]);
    const addRowRef = useRef(null);
    const addPlannerRef = useRef(null);

    const initialPlanner = {
        taskTitle: "",
        taskDescription: "",
        startDate: "",
        endDate: "",
        estimatedHours: "",
        estimatedMinutes: "",
        assignTo: [],
    };

    const [plannerData, setPlannerData] = useState([initialPlanner]);
    const [showPlannerNameModal, setShowPlannerNameModal] = useState(false);
    const [plannerName, setPlannerName] = useState("");

    const { assignToOptions } = useSelfAssignToOptions()

    useEffect(() => {
        if (editData) {
            setPlannerName(editData?.plannerName || "");
            const updatedTaskList = editData?.taskList?.map((task) => ({
                taskTitle: task?.taskTitle || "",
                taskDescription: task?.taskDescription || "",
                startDate: task?.startDate || "",
                endDate: task?.endDate || "",
                estimatedHours: task?.estimatedHours || "",
                estimatedMinutes: task?.estimatedMinutes || "",
                assignTo: task?.assignTo
                    ? [{
                        label: task?.assignToName,
                        value: task?.assignTo,
                    }]
                    : [],
                _id: task?._id,
                planTaskId: task?.planTaskId,
            })) || [];
            setPlannerData(updatedTaskList);
        }

    }, [editData]);

    // handle input
    const handleChange = (index, field, value) => {
        const updatedPlanner = [...plannerData];
        updatedPlanner[index][field] = value;
        setPlannerData(updatedPlanner);
    };

    const taskTitleRefs = useRef([]);
    // add planner row
    const handleAddPlanner = () => {
        setPlannerData([
            ...plannerData,
            initialPlanner
        ]);
        setErrors([
            ...errors,
            {}
        ]);
    };

    // remove planner row
    // const handleRemovePlanner = (index) => {
    //     const updatedPlanner = plannerData.filter(
    //         (_, i) => i !== index
    //     );
    //     const updatedErrors = errors.filter(
    //         (_, i) => i !== index
    //     );
    //     setPlannerData(updatedPlanner);
    //     setErrors(updatedErrors);
    // };

    const handleRemovePlanner = async (index) => {
        const row = plannerData[index];

        try {
            if (row?.planTaskId) {
                await axios.post(
                    process.env.REACT_APP_BASE_URL + "/planner/deletePlanner",
                    {
                        planTaskId: row.planTaskId,
                    }
                );

                toast.success("Planner Task Deleted Successfully");
            }

            // UI se row remove karo
            const updatedPlanner = plannerData.filter(
                (_, i) => i !== index
            );

            const updatedErrors = errors.filter(
                (_, i) => i !== index
            );

            setPlannerData(updatedPlanner);
            setErrors(updatedErrors);

        } catch (error) {
            console.log("Delete Error", error);
            toast.error("Failed to delete planner task");
        }
    };

    // clone planner row
    const handleClonePlannerRow = (index) => {
        const rowToClone = {
            ...plannerData[index],
            _id: undefined,
            planTaskId: undefined,
        };

        const updatedPlanner = [...plannerData];

        updatedPlanner.splice(
            index + 1,
            0,
            rowToClone
        );

        setPlannerData(updatedPlanner);
    };


    const validatePlanner = () => {
        let tempErrors = [];
        let isValid = true;
        plannerData.forEach((item, index) => {

            let plannerError = {};

            if (!item.taskTitle.trim()) {
                plannerError.taskTitle = "Task Title is required";
                isValid = false;
            }

            if (!item.taskDescription.trim()) {
                plannerError.taskDescription = "Task Description is required";
                isValid = false;
            }

            const isAssignToValid = isEdit
                ? !!item.assignTo
                : item.assignTo?.length > 0;

            if (!isAssignToValid) {
                plannerError.assignTo = "Assign To is required";
                isValid = false;
            }

            if (!item.startDate) {
                plannerError.startDate = "Start Date is required";
                isValid = false;
            }

            if (!item.endDate) {
                plannerError.endDate = "End Date is required";
                isValid = false;
            }

            if (!item.estimatedHours) {
                plannerError.estimatedHours = "Estimated Hours is required";
                isValid = false;
            }

            if (
                item.estimatedMinutes === "" ||
                item.estimatedMinutes === null
            ) {
                plannerError.estimatedMinutes = "Estimated Minutes is required";
                isValid = false;
            }

            // minute validation
            if (
                item.estimatedMinutes > 59 ||
                item.estimatedMinutes < 0
            ) {
                plannerError.estimatedMinutes =
                    "Minutes should be between 0 to 59";

                isValid = false;
            }

            // both zero validation
            if (
                Number(item.estimatedHours) === 0 &&
                Number(item.estimatedMinutes) === 0
            ) {
                plannerError.estimatedHours =
                    "Hours and Minutes both cannot be 0";

                plannerError.estimatedMinutes =
                    "Hours and Minutes both cannot be 0";

                isValid = false;
            }

            // end date validation
            if (
                item.startDate &&
                item.endDate &&
                item.endDate < item.startDate
            ) {
                plannerError.endDate =
                    "End Date cannot be before Start Date";

                isValid = false;
            }

            tempErrors[index] = plannerError;
        });
        setErrors(tempErrors);
        return isValid;

    };

    const validatePlannerHours = () => {

        const dateWiseMinutes = {};

        for (let i = 0; i < plannerData.length; i++) {

            const item = plannerData[i];

            const start = new Date(item.startDate);
            const end = new Date(item.endDate);

            const hr = parseInt(item.estimatedHours || 0);
            const min = parseInt(item.estimatedMinutes || 0);

            const diffDays =
                Math.ceil((end - start) / (1000 * 60 * 60 * 24)) + 1;

            const totalMinutes = hr * 60 + min;
            const maxMinutes = diffDays * 24 * 60;

            // minimum 2 hr validation
            if (
                item.startDate !== item.endDate &&
                totalMinutes < 120
            ) {
                toast.error(
                    `Row ${i + 1}: If start date and end date are different, minimum 2 hr is required.`
                );
                return false;
            }

            // max hours validation
            if (totalMinutes > maxMinutes) {
                toast.error(
                    `Row ${i + 1}: Maximum allowed is ${diffDays * 24} hours for ${diffDays} day(s).`
                );
                return false;
            }

            // single row max 24 hr
            if (diffDays === 1) {
                if (hr > 24 || (hr === 24 && min > 0)) {
                    toast.error(
                        `Row ${i + 1}: For one day, max allowed is 24 hr 00 min.`
                    );
                    return false;
                }
            }

            // SAME DATE TOTAL VALIDATION
            let currentDate = new Date(start);

            while (currentDate <= end) {

                const dateKey = currentDate
                    .toISOString()
                    .split("T")[0];

                // distribute minutes equally per day
                const perDayMinutes =
                    totalMinutes / diffDays;

                if (!dateWiseMinutes[dateKey]) {
                    dateWiseMinutes[dateKey] = 0;
                }

                dateWiseMinutes[dateKey] += perDayMinutes;

                // max 24 hr per same date
                if (dateWiseMinutes[dateKey] > 1440) {

                    toast.error(
                        `Total task hours for ${dateKey} cannot exceed 24 hours.`
                    );

                    return false;
                }

                currentDate.setDate(
                    currentDate.getDate() + 1
                );
            }
        }

        return true;
    };

    // handler submit data
    const handleProceedPlanner = async () => {

        if (!plannerName.trim()) {
            alert("Please Enter Planner Name");
            return;
        }
        const payload = {
            plannerName: plannerName,
            planeGroupId: editData?.planeGroupId || "",
            // taskList: plannerData.map((item) => ({
            //     ...(item?._id && { _id: item._id }),
            //     ...(item?.planTaskId && { planTaskId: item.planTaskId }),
            //     // _id: item?._id,
            //     // planTaskId: item?.planTaskId,
            //     taskTitle: item.taskTitle,
            //     taskDescription: item.taskDescription,
            //     startDate: item.startDate,
            //     endDate: item.endDate,
            //     estimatedHours: item.estimatedHours,
            //     estimatedMinutes: item.estimatedMinutes,
            //     assignTo: item.assignTo?.value,
            //     assignToName: item.assignTo?.label,
            //     projectId: loginUserData?.assignedProjects?.[0]?.projectId,
            //     projectName: loginUserData?.assignedProjects?.[0]?.projName,
            //     assignBy_id: loginUserData?.empId,
            //     assignBy_Name: `${loginUserData?.firstName} ${loginUserData?.lastName}`,
            // })),
            taskList: isEdit
                ? plannerData.map((item) => ({
                    ...(item?._id && { _id: item._id }),
                    ...(item?.planTaskId && { planTaskId: item.planTaskId }),
                    taskTitle: item.taskTitle,
                    taskDescription: item.taskDescription,
                    startDate: item.startDate,
                    endDate: item.endDate,
                    estimatedHours: item.estimatedHours,
                    estimatedMinutes: item.estimatedMinutes,
                    assignTo: item.assignTo?.value,
                    assignToName: item.assignTo?.label,
                    projectId: loginUserData?.assignedProjects?.[0]?.projectId,
                    projectName: loginUserData?.assignedProjects?.[0]?.projName,
                    assignBy_id: loginUserData?.empId,
                    assignBy_Name: `${loginUserData?.firstName} ${loginUserData?.lastName}`,
                }))
                : plannerData.flatMap((item) =>
                    item.assignTo.map((emp) => ({
                        ...(item?._id && { _id: item._id }),
                        ...(item?.planTaskId && { planTaskId: item.planTaskId }),
                        taskTitle: item.taskTitle,
                        taskDescription: item.taskDescription,
                        startDate: item.startDate,
                        endDate: item.endDate,
                        estimatedHours: item.estimatedHours,
                        estimatedMinutes: item.estimatedMinutes,
                        assignTo: emp.value,
                        assignToName: emp.label,
                        projectId: loginUserData?.assignedProjects?.[0]?.projectId,
                        projectName: loginUserData?.assignedProjects?.[0]?.projName,
                        assignBy_id: loginUserData?.empId,
                        assignBy_Name: `${loginUserData?.firstName} ${loginUserData?.lastName}`,
                    }))
                )
        };
        try {

            let res;
            if (isEdit) {
                res = await axios.post(process.env.REACT_APP_BASE_URL + "/planner/bulkUpdatePlanner", payload);
            } else {
                res = await axios.post(process.env.REACT_APP_BASE_URL + "/planner/addBulkPlanner", payload);
            }
            setShowPlannerNameModal(false);
            setPlannerName("");
            setPlannerData([initialPlanner]);
            setErrors([]);
            close();
            setTimeout(() => {
                getAllPlanner();
            }, 0);
            toast.success(isEdit ? "Planner Updated Successfully" : "Planner Added Successfully");

        } catch (err) {
            console.log("error", err);
        }
    };

    return (
        <>
            <Modal
                show={show}
                onHide={close}
                size="xl"
                centered
                backdrop="static"
            >

                <Modal.Header closeButton className="mngmodelheader">
                    <Modal.Title>
                        <h5 className="mb-0">{isEdit ? "Edit Planner" : "Create Planner"}</h5>
                    </Modal.Title>
                </Modal.Header>

                <Modal.Body>

                    <div className="table-responsive">
                        {/* <table className="table table-bordered align-middle"> */}
                        <table className="table table-bordered planner-table">
                            <thead className="table-dark">
                                <tr>
                                    <th>Task Title</th>
                                    <th>Description</th>
                                    <th>Start Date</th>
                                    <th>End Date</th>
                                    <th>Hours</th>
                                    <th>Minutes</th>
                                    <th>Assign To</th>
                                    <th>Action</th>
                                </tr>
                            </thead>

                            <tbody>

                                {
                                    plannerData.map((planner, index) => (
                                        <tr key={index}>

                                            {/* Task Title */}
                                            <td>
                                                <Form.Control
                                                    as="textarea"
                                                    tabIndex={1 + index * 7}
                                                    rows={2}
                                                    placeholder="Enter Task Title"
                                                    value={planner.taskTitle}
                                                    onChange={(e) =>
                                                        handleChange(
                                                            index,
                                                            "taskTitle",
                                                            e.target.value
                                                        )
                                                    }
                                                />

                                                {
                                                    errors[index]?.taskTitle &&
                                                    <small className="text-danger">
                                                        {errors[index]?.taskTitle}
                                                    </small>
                                                }
                                            </td>

                                            {/* Description */}
                                            <td>
                                                <Form.Control
                                                    as="textarea"
                                                    tabIndex={2 + index * 7}
                                                    rows={2}
                                                    placeholder="Description"
                                                    value={planner.taskDescription}
                                                    onChange={(e) =>
                                                        handleChange(
                                                            index,
                                                            "taskDescription",
                                                            e.target.value
                                                        )
                                                    }
                                                />

                                                {
                                                    errors[index]?.taskDescription &&
                                                    <small className="text-danger">
                                                        {errors[index]?.taskDescription}
                                                    </small>
                                                }
                                            </td>

                                            {/* Start Date */}
                                            <td>
                                                <Form.Control
                                                    type="date"
                                                    tabIndex={3 + index * 7}
                                                    onPaste={(e) => e.preventDefault()}
                                                    onKeyDown={(e) => {
                                                        if (e.key === "Tab") {
                                                            e.preventDefault();

                                                            const next =
                                                                document.querySelector(
                                                                    `[tabindex="${4 + index * 7}"]`
                                                                );

                                                            next?.focus();
                                                        }
                                                    }}
                                                    value={planner.startDate}
                                                    onChange={(e) =>
                                                        handleChange(
                                                            index,
                                                            "startDate",
                                                            e.target.value
                                                        )
                                                    }
                                                />

                                                {
                                                    errors[index]?.startDate &&
                                                    <small className="text-danger">
                                                        {errors[index]?.startDate}
                                                    </small>
                                                }
                                            </td>

                                            {/* End Date */}
                                            <td>
                                                <Form.Control
                                                    type="date"
                                                    tabIndex={4 + index * 7}
                                                    onPaste={(e) => e.preventDefault()}
                                                    onKeyDown={(e) => {
                                                        if (e.key === "Tab") {
                                                            e.preventDefault();

                                                            const next =
                                                                document.querySelector(
                                                                    `[tabindex="${5 + index * 7}"]`
                                                                );

                                                            next?.focus();
                                                        }
                                                    }}
                                                    min={planner.startDate}
                                                    value={planner.endDate}
                                                    onChange={(e) =>
                                                        handleChange(
                                                            index,
                                                            "endDate",
                                                            e.target.value
                                                        )
                                                    }
                                                />

                                                {
                                                    errors[index]?.endDate &&
                                                    <small className="text-danger">
                                                        {errors[index]?.endDate}
                                                    </small>
                                                }
                                            </td>

                                            {/* Hours */}
                                            <td>
                                                <Form.Control
                                                    placeholder="HH"
                                                    tabIndex={5 + index * 7}
                                                    value={planner.estimatedHours}
                                                    onChange={(e) => {
                                                        const value = e.target.value;
                                                        if (
                                                            /^[0-9]*$/.test(value) &&
                                                            value.length <= 3
                                                        ) {
                                                            handleChange(
                                                                index,
                                                                "estimatedHours",
                                                                value
                                                            );
                                                        }
                                                    }}
                                                />

                                                {
                                                    errors[index]?.estimatedHours &&
                                                    <small className="text-danger">
                                                        {errors[index]?.estimatedHours}
                                                    </small>
                                                }
                                            </td>

                                            {/* Minutes */}
                                            <td>
                                                <Form.Control
                                                    placeholder="MM"
                                                    tabIndex={6 + index * 7}
                                                    value={planner.estimatedMinutes}
                                                    onChange={(e) => {
                                                        const value = e.target.value;

                                                        if (
                                                            /^[0-9]{0,2}$/.test(value) &&
                                                            value <= 59
                                                        ) {
                                                            handleChange(
                                                                index,
                                                                "estimatedMinutes",
                                                                value
                                                            );
                                                        }
                                                    }}
                                                />

                                                {
                                                    errors[index]?.estimatedMinutes &&
                                                    <small className="text-danger">
                                                        {errors[index]?.estimatedMinutes}
                                                    </small>
                                                }
                                            </td>

                                            {/* Assign To */}
                                            <td style={{ minWidth: "180px" }}>
                                                <Select
                                                    isMulti={!isEdit}
                                                    classNamePrefix="react-select"
                                                    tabIndex={7 + index * 7}
                                                    options={assignToOptions}
                                                    value={planner.assignTo}
                                                    menuPortalTarget={document.body}
                                                    menuPosition="fixed"
                                                    menuShouldScrollIntoView={false}
                                                    tabSelectsValue={true}
                                                    onKeyDown={(e) => {
                                                        if (e.key === "Tab") {
                                                            e.preventDefault();

                                                            setTimeout(() => {
                                                                addRowRef.current?.focus();
                                                            }, 0);
                                                        }
                                                    }}
                                                    styles={{
                                                        menuPortal: (base) => ({
                                                            ...base,
                                                            zIndex: 9999,
                                                        }),

                                                        menu: (base) => ({
                                                            ...base,
                                                            zIndex: 9999,
                                                        }),
                                                    }}
                                                    onChange={(value) => {
                                                        handleChange(index, "assignTo", value)
                                                        setTimeout(() => {
                                                            addRowRef.current?.focus();
                                                        }, 0);
                                                    }
                                                    }
                                                />

                                                {
                                                    errors[index]?.assignTo &&
                                                    <small className="text-danger">
                                                        {errors[index]?.assignTo}
                                                    </small>
                                                }
                                            </td>

                                            {/* Action */}
                                            <td className="text-center">
                                                <div
                                                    className="d-flex justify-content-center align-items-center gap-2"
                                                >

                                                    <Button
                                                        variant="primary"
                                                        className="action-btn"
                                                        title="Clone Row"
                                                        onClick={() => handleClonePlannerRow(index)}
                                                    >
                                                        <Icon.Files />
                                                    </Button>

                                                    {
                                                        plannerData.length > 1 &&
                                                        <Button
                                                            variant="danger"
                                                            className="action-btn"
                                                            title="Delete Row"
                                                            onClick={() => handleRemovePlanner(index)}
                                                        >
                                                            <Icon.Trash />
                                                        </Button>
                                                    }

                                                </div>
                                            </td>

                                        </tr>
                                    ))
                                }

                            </tbody>
                        </table>
                    </div>

                    <div className="mt-3 text-end">
                        <Button
                            ref={addRowRef}
                            tabIndex={999}
                            className="primaryBtn add-row-btn"
                            onClick={handleAddPlanner}
                            onKeyDown={(e) => {
                                if (e.key === "Enter") {
                                    e.preventDefault();
                                    handleAddPlanner();
                                }
                            }}
                        >
                            <Icon.PlusCircle className="me-2" />
                            Add Row
                        </Button>
                    </div>

                </Modal.Body>

                <Modal.Footer>
                    <Button
                        className="activeBtn footer-btn"
                        ref={addPlannerRef}
                        onKeyDown={(e) => {
                            if (e.key === "Enter") {
                                e.preventDefault();

                                handleAddPlanner();

                                setTimeout(() => {
                                    addPlannerRef.current?.focus();
                                }, 100);
                            }
                        }}
                        onClick={async () => {
                            const isValid = validatePlanner();
                            if (!isValid) return;
                            const isHourValid = validatePlannerHours();
                            if (!isHourValid) return;
                            if (!isEdit) {
                                setShowPlannerNameModal(true);
                            } else {
                                await handleProceedPlanner();
                            }
                        }}
                    >
                        {isEdit ? "Update Planner" : "Add Planner"}
                    </Button>
                </Modal.Footer>

            </Modal>

            {/* modal for planner name */}
            <Modal
                show={showPlannerNameModal}
                onHide={() => setShowPlannerNameModal(false)}
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title>
                        Enter Planner Name
                    </Modal.Title>
                </Modal.Header>

                <Modal.Body>

                    <Form.Group>
                        <Form.Label>
                            Planner Name
                        </Form.Label>

                        <Form.Control
                            as="textarea"
                            tabIndex={1000}
                            rows={3}
                            placeholder="Enter Planner Name"
                            value={plannerName}
                            onChange={(e) =>
                                setPlannerName(e.target.value)
                            }
                        />
                    </Form.Group>

                </Modal.Body>

                <Modal.Footer>

                    <Button
                        tabIndex={1001}
                        variant="secondary"
                        onClick={() =>
                            setShowPlannerNameModal(false)
                        }
                    >
                        Cancel
                    </Button>

                    <Button
                        className="activeBtn"
                        onClick={handleProceedPlanner}
                    >
                        Proceed
                    </Button>

                </Modal.Footer>
            </Modal>
        </>

    );
};

export default CreatePlannerModal;